import { useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { betaKeys } from "@/lib/query-keys";
import type { UserExtraInformation } from "@/types/domain";

export function useBetaInformation(enabled = true) {
  return useQuery({
    queryKey: betaKeys.info,
    enabled,
    retry: false,
    queryFn: async () => {
      const res = await fetchToBackend<any>(
        "/userextrainformation/getBetaInformation",
      );
      return (res?.data ?? res) as UserExtraInformation;
    },
  });
}
